export default "__VITE_ASSET__c735802e__"